var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSearchCrew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 14.1792C17.349 14.1792 19.1523 13.4323 20.4819 12.1027C21.8114 10.7732 22.5584 8.96989 22.5584 7.08961C22.5584 5.20933 21.8114 3.40606 20.4819 2.0765C19.1523 0.746939 17.349 0 15.4688 0C13.5885 0 11.7852 0.746939 10.4556 2.0765C9.12608 3.40606 8.37914 5.20933 8.37914 7.08961C8.37914 8.96989 9.12608 10.7732 10.4556 12.1027C11.7852 13.4323 13.5885 14.1792 15.4688 14.1792ZM15.4688 17.2941C6.04266 17.2941 0 22.4958 0 25.0284V29.7577H30.9375V25.0284C30.9375 21.9656 25.2169 17.2941 15.4688 17.2941Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSearchCrew);
export default __webpack_public_path__ + "static/media/HomeSearchCrew.cfc1b22fa3d631ffbc14692fae0e6277.svg";
export { ForwardRef as ReactComponent };